<template>
  <div class="login-containers pull-height">
    <div class="left">
      <!-- <header class="top">
        <div class="mark"></div>
        <div class="logo">
          <img src="../../static/login/qyb.png" alt="">
          <div class="dec">
            <h1>捷运途土石方行业</h1>
            <h2>智能运营平台</h2>
          </div>
        </div>
      </header>
      <content class="bottom">
        <img src="../../static/login/dlzc_t.png" alt="">
        <div class="content">
          <p><span style="font-size:0.18rem">实现</span>土方运输过程闭环管理，<span style="font-size:0.18rem">减少</span>舞弊损失和漏洞</p>
          <p>提升内部结算<span>管理效能</span>，帮助施工单位<span>降本增效</span></p>
          <p>赋能施工单位<span>业务流、信息流、资金流、票据流、货物轨迹流</span>“五流合一”</p>
          <p>确保业务的<span>完整性</span>和<span>真实性</span>以及运输全过程的<span>可监控、可追溯</span></p>
          <div class="line"></div>
        </div>
      </content> -->
      <div class="title_left">
        <img
          src="../../static/login/index.png"
          alt=""
          style="width: 5.07rem; height: 2.84rem"
        />
        <div class="title_left_top">全流程数字化管理平台</div>
        <div class="bootm">
          <div>项目全流程管理</div>
          <div>智能签单进出场</div>
          <div>撮合促成交易</div>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="login-weapers">
        <div class="login-borders animated fadeInRight">
          <div class="login-mains">
            <buildLoginCom />
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div>深圳睿安智行科技信息服务有限公司</div>
      <div>
        <span>copyright © 2024 jab9.top 版权所有</span>
        <span style="padding: 0 6px">|</span>
        <a
          target="_blank"
          href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
          >粤ICP备2024262201号
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import buildLoginCom from "./buildLoginCom";
import { mapGetters } from "vuex";
import { getStore, setStore } from "@/util/store";
import { dateFormat } from "@/util/date";
import { validatenull } from "@/util/validate";
// import topColor from "@/page/index/top/top-color";
export default {
  name: "login",
  components: {
    buildLoginCom,
  },
  data() {
    return {
      time: "",
      activeName: this.$route.meta.activeName,
      thirdPartyForm: {},
    };
  },
  watch: {
    $route: {
      handler() {
        const params = this.$route.query;
        if (validatenull(params.state) && validatenull(params.code)) return;

        this.thirdPartyForm.state = params.state || "";
        this.thirdPartyForm.code = params.code || "";
        this.$store
          .dispatch("LoginByThirdParty", this.thirdPartyForm)
          .then(() => {
            this.$store.commit("SET_TOP_MENU_INDEX", 0);
            this.$router.push({ path: this.tagWel.value });
          })
          .catch(() => {});
      },
      immediate: true,
    },
  },
  created() {
    // this.getTime();
    // setInterval(() => {
    //   this.getTime();
    // }, 1000);
  },
  mounted() {
    this.fnResize();
    window.addEventListener("resize", this.fnResize);
  },
  computed: {
    ...mapGetters(["website", "tagWel"]),
  },
  props: [],
  methods: {
    getTime() {
      this.time = dateFormat(new Date());
      console.log(this.time);
    },
    fnResize() {
      var deviceWidth =
        document.documentElement.clientWidth || window.innerWidth;
      if (deviceWidth >= 1920) {
        deviceWidth = 1920;
      }
      if (deviceWidth <= 1080) {
        deviceWidth = 1080;
      }
      document.documentElement.style.fontSize = deviceWidth / 19.2 + "px";
    },
  },
  beforeDestroy() {
    document.documentElement.style.fontSize = "16px";
    window.removeEventListener("resize", this.fnResize);
  },
  // beforeRouteLeave(to, from, next) {
  //   document.documentElement.style.fontSize = '16px';
  //    next() // 下一步
  // }
};
</script>

<style lang="scss" scoped>
.login-containers {
  width: 100%;
  height: 100%;
  // background-color: #f5f5f5;
  display: flex;
  .left {
    width: calc(100% - 520px);
    padding-left: 0.3rem;
    height: 100%;
    position: relative;
    background: url("../../static/login/login_bg.png");
    background-repeat: no-repeat;
    background-size:100% 100% ;
    // background-size: 111%;
    // .top{
    //   height: 3.8rem;
    //   display: flex;
    //   justify-content: flex-start;
    //   align-items: flex-start;
    //   .mark{
    //     width: 1.5rem;
    //     height: 3.8rem;
    //     background: linear-gradient(180deg, #108EE9 0%, rgba(16, 142, 233, 0) 100%);
    //     opacity: 0.17;
    //     margin-right: 0.6rem;
    //   }
    //   .logo{
    //     display: flex;
    //     align-items: center;
    //     margin-top: 0.5rem;
    //     img{
    //       width: 0.8rem;
    //       height: 0.8rem;
    //       margin-right: 0.2rem;
    //     }
    //     .dec{
    //       h1{
    //         font-size: 0.28rem;
    //         font-family: PingFang SC;
    //         font-weight: 400;
    //         line-height: 0.44rem;
    //         color: #353347;
    //         opacity: 1;
    //       }
    //       h2{
    //         font-family: PingFang SC;
    //         font-weight: 400;
    //         line-height: 0.44rem;
    //         opacity: 1;
    //         font-size: 0.21rem;
    //         color: #817f8b;
    //       }
    //     }
    //   }
    // }
    // .bottom{
    //   position: absolute;
    //   bottom: 0;
    //   left: 0.3rem;
    //   img{
    //     width: 6.3rem;
    //     height: 6.3rem;
    //     // width: 89.3vh;
    //     // height: 89.3vh;

    //   }
    //   .content{
    //     position: absolute;
    //     top:-0.5rem;
    //     right:-2.5rem;
    //     font-size: 0.16rem;
    //     font-family: PingFang SC;
    //     font-weight: bold;
    //     line-height: 0.44rem;
    //     color: #353347;
    //     span{
    //       color: #108EE9;
    //     }
    //     .line{
    //       width: 0.6rem;
    //       height: 0.1rem;
    //       background: rgba(16, 142, 233, 1);
    //       margin-top: 0.3rem;
    //     }
    //   }
    // }
  }
  .right {
    width: 520px;

    // background: rgba(16, 142, 233, 1);
    background: url("../../static/login/right-background.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    // background-size: 111%;
    // position: relative;
    // background-size: 22%;
    /deep/ .login-weapers {
      // height: 7.2rem;

      // box-shadow: 0px 0.03rem 0.06rem rgba(27, 27, 28, 0.07);
      opacity: 1;
      // border-radius: 0.18rem;
      // height: 64vh;
      background-color: #fff;
      position: relative;
      // top:1.2rem;
      // left:-2.6rem;

      margin: auto;
      padding: 0px 0.4rem 0px 0.4rem;
      // width: 18vw;
      .el-radio-button--medium .el-radio-button__inner {
        // padding: 0.1rem 0.2rem;
        font-size: 0.14rem;
      }
      .code-phone-div {
        .iconImg {
          position: absolute;
          right: 0.3rem;
          top: 0.2rem;
          width: 12px;
          height: 16px;
        }
        .code-phone-title {
          padding-top: 0.7rem;
          margin-bottom: 0.6rem;
          // width: 4.04rem;
          height: 0.94rem;
          font-size: 0.24rem;
          font-family: PingFang SC;
          font-weight: 500;
          line-height: 0.46rem;
          color: #353347;
          div {
            font-weight: 500;
            font-size: 0.24rem;
            color: #2e3133;
          }
          .code-phone-subtitle {
            // font-size: 0.20rem;
            font-weight: 400;
          }
        }
      }
      .el-form-item {
        height: 0.4rem;
        margin-bottom: 0.3rem;
        .el-form-item__content {
          height: 0.4rem;
          .el-input {
            height: 0.4rem;
          }
          input {
            height: 0.4rem;
            padding-left: 0.4rem;
          }
          .el-input__prefix {
            width: 0.32rem;
            // display: inline-block;
            height: 0.4rem;
            position: relative;
            left: 0;
            top: -0.38rem;
            img {
              width: 0.32rem;
              height: 0.25rem;
              left: 0;
              top: 5px;
              position: absolute;
            }
          }
          .code {
            display: flex;
            align-items: center;
            .el-input__prefix {
              display: inline-block;
              left: 0;
              top:5px;
              position: absolute;
            }
          }
        }
      }
      .check {
        color: #353347;
        font-size: 0.16rem;
        margin-top: 0.8rem;
        margin-bottom: 0.2rem;
        a {
          color: #108ee9;
        }
      }
      .btn {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 0.64rem;
        line-height: 0.64rem;
        .code-phone-submit {
          width: 3.8rem;
          height: 0.64rem;
          background: rgba(16, 142, 233, 1);
          border-radius: 0.44rem;
          font-size: 0.28rem;
        }
      }
    }
  }
}
.footer {
  position: absolute;
  bottom: 15px;
  text-align: center;
  width: 100%;
  color: #606266;
  font-size: 14px;
  a {
    color: blue;
  }
}

.title_left {
  margin-left: 1.65rem;
  margin-top: 0.98rem;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 80px;
  color: #ffffff;

  letter-spacing: 2px;
  text-align: left;
  font-style: normal;

  .title_left_top {
    white-space: nowrap; /* 禁止换行 */
    overflow: hidden; /* 超出部分隐藏 */
    text-overflow: ellipsis; /* 显示省略号 */
    line-height: 1.12rem;
  }
}

.bootm {
  margin-top: 2.55rem;
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
  display: flex;
  div {
    margin-right: 0.2rem;
    padding: 0.13rem 0.24rem;
    border: 1px solid #ffffff;
    border-radius: 0.28rem;
  }
}
</style>
